// Central registry of external project links (repo, demo, docs, funding).
// Keep these in one place so the demo banner, login screen, settings "About"
// card, and any future surface all point at the same canonical URLs.
export const LINKS = {
  github: 'https://github.com/sgiraz/homelog',
  githubIssues: 'https://github.com/sgiraz/homelog/issues',
  githubSponsors: 'https://github.com/sponsors/sgiraz',
  kofi: 'https://ko-fi.com/sgiraz',
  demo: 'https://demo.homelog.dev',
  landing: 'https://homelog.dev',
  docs: 'https://docs.homelog.dev',
}
